const SearchOutlineIcon = ({
  width = 27,
  height = 27,
  stroke = "black",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.1112 23.2225C18.2478 23.2225 23.2225 18.2478 23.2225 12.1112C23.2225 5.97467 18.2478 1 12.1112 1C5.97467 1 1 5.97467 1 12.1112C1 18.2478 5.97467 23.2225 12.1112 23.2225Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.9988 25.9997L19.957 19.958"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SearchOutlineIcon;
